<div class="readonly-field">
  <label class="readonly-label">{{ props.label }}</label>
  @if (isCheckbox && displayValue() !== null) {
  <span class="readonly-value">{{ displayValue()! | translate }}</span>
  } @else if (displayValue() !== null) {
  <span class="readonly-value">{{ displayValue() }}</span>
  } @else {
  <span class="readonly-value readonly-empty">{{ 'submission.view.noValue' | translate }}</span>
  }
</div>